
    import './styles.scoped.css';
    export default {
  "slider": "awsui_slider_cqzlk_1ksjn_99",
  "slider-side": "awsui_slider-side_cqzlk_1ksjn_134",
  "slider-icon": "awsui_slider-icon_cqzlk_1ksjn_141",
  "slider-icon-bottom": "awsui_slider-icon-bottom_cqzlk_1ksjn_147",
  "slider-icon-side": "awsui_slider-icon-side_cqzlk_1ksjn_151"
};
  